import { textBody } from 'libs/growth-platform-brand-system-v2/src/styles/typography';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import { getMenuTrackEvent } from 'libs/growth-platform-brand-system-v2/src/utils/tracking';
import { ButtonTracking } from 'libs/growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';
import morphism from 'morphism';
import React from 'react';
import { schemaDatoButton } from '../../morphismSchema/schemaDatoButton';
import { addUnbreakableSpace } from '../../utils/textUtils';
import { menuItemCn } from './styles';
import { isBlogArticle, isClientLink } from './submenu/SubMenuContent';

export const MenuLink = ({ menuItem, locale, index }: any) => {
  const { as, __typename, color, variant, ...linkProps } = morphism(
    schemaDatoButton,
    {
      ...menuItem,
      isBlogArticle: isBlogArticle(menuItem.internalUrl?.__typename),
      isClientLink: isClientLink(menuItem.internalUrl?.__typename),
      locale,
    },
  );

  const trackEvent = getMenuTrackEvent({
    locale,
    menuItem,
  });

  return (
    <li
      className={classNames(
        'menuItem xl:mb-0 xl:mt-0 text-neutral-301 whitespace-nowrap',
      )}
    >
      <ButtonTracking
        component={as}
        key={index}
        {...linkProps}
        labelTracking={menuItem.title}
        trackEvent={trackEvent}
        section="header_menuItems"
        index={index}
        className={classNames(menuItemCn)}
      >
        <span
          className={classNames(
            textBody,
            'font-medium xl:font-normal',
            'first-level cursor-pointer text-neutral-301',
          )}
        >
          {addUnbreakableSpace(menuItem.title)}
        </span>
      </ButtonTracking>
    </li>
  );
};
